const ProjectDetailsTab = {
    TIME_LOG: 0,
    RECORD: 1,
    FILES: 2,
    STATISTIC: 3,
    PROJECT_ACCESS: 4,
    PROJECT_TASK_CATEGORIES: 5,
}

export default ProjectDetailsTab;